import axios from 'axios';
import moment from 'moment';

export const STRIPE_PRORATION_LOADING = 'STRIPE_PRORATION_LOADING';
export const STRIPE_PRORATION_SUCCESS = 'STRIPE_PRORATION_SUCCESS';
export const STRIPE_PRORATION_ERROR = 'STRIPE_PRORATION_ERROR';

export const PREVIEW_PRORATION_LOADING = 'PREVIEW_PRORATION_LOADING';
export const PREVIEW_PRORATION_SUCCESS = 'PREVIEW_PRORATION_SUCCESS';
export const PREVIEW_PRORATION_ERROR = 'PREVIEW_PRORATION_ERROR';

export function previewProration(subscriptionId, newPlanId, callback) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch({ type: PREVIEW_PRORATION_LOADING });
    axios
      .get(
        `${
          process.env.REACT_APP_BACKEND_URL
        }/stripe/subscriptions/${subscriptionId}/previewProration?newPlanId=${newPlanId}`,
        {
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${state.user.token}`
          }
        }
      )
      .then(response => {
        callback && callback();
        dispatch({
          type: PREVIEW_PRORATION_SUCCESS,
          payload: response.data.data
        });
      })
      .catch(result => {
        dispatch({
          type: PREVIEW_PRORATION_ERROR,
          payload: result
        });
      });
  };
}

export function getStripeProration(
  customerId,
  subscriptionId,
  subscriptionItemId,
  newPlanId,
  callback
) {
  return dispatch => {
    dispatch({ type: STRIPE_PRORATION_LOADING });

    const prorationDate = moment().format('X');

    axios
      .get(
        `${
          process.env.REACT_APP_STRIPE_HOST_URL
        }/invoices/upcoming?customer=${customerId}&subscription=${subscriptionId}` +
        `&subscription_proration_date=${prorationDate}&subscription_items[0][id]=${subscriptionItemId}` +
        `&subscription_items[0][plan]=${newPlanId}`,
        {
          headers: {
            Authorization: `Bearer ${process.env.REACT_APP_STRIPE_SECRET_KEY}`
          }
        }
      )
      .then(response => {
        callback && callback();

        dispatch({
          type: STRIPE_PRORATION_SUCCESS,
          payload: { proration_date: prorationDate, invoice: response.data }
        });
      })
      .catch(result => {
        dispatch({
          type: STRIPE_PRORATION_ERROR,
          payload: result
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/stripeProrationActions.js